import React from 'react';

/** Lazy ClientComputedSubNavigation (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedSubNavigation = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-sub-navigation' */
            './ClientComputedSubNavigation'
        ),
);
